var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpgradePlanBgExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 11.5,
    fill: "#FFF3E4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 11.5,
    stroke: "#FAA53D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_393_972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8411 17.1919C37.5549 16.9531 37.2075 16.7995 36.8382 16.7486C36.469 16.6978 36.0929 16.7518 35.7529 16.9044L29.4299 19.7147L25.7484 13.0879C25.5752 12.7761 25.3218 12.5163 25.0144 12.3354C24.707 12.1545 24.3568 12.0591 24.0001 12.0591C23.6434 12.0591 23.2933 12.1545 22.9859 12.3354C22.6785 12.5163 22.425 12.7761 22.2518 13.0879L18.5702 19.7146L12.2462 16.9039C11.906 16.7527 11.5303 16.6995 11.1614 16.7503C10.7926 16.8011 10.4452 16.9538 10.1584 17.1913C9.87167 17.4288 9.6569 17.7416 9.53828 18.0945C9.41967 18.4475 9.40193 18.8265 9.48706 19.189L12.6677 32.7306C12.7282 32.9928 12.8416 33.2398 13.0008 33.4567C13.16 33.6736 13.3618 33.8558 13.5937 33.9921C13.8269 34.1293 14.0853 34.2184 14.3536 34.2538C14.6219 34.2893 14.8945 34.2705 15.1554 34.1985C20.9416 32.6011 27.0525 32.6005 32.839 34.1968C33.0997 34.2687 33.3723 34.2874 33.6404 34.252C33.9085 34.2165 34.1668 34.1276 34.3999 33.9904C34.6318 33.8542 34.8335 33.6722 34.9927 33.4554C35.1519 33.2387 35.2653 32.9918 35.3259 32.7299L38.5121 19.1901C38.5988 18.8276 38.5818 18.448 38.4632 18.0947C38.3445 17.7414 38.129 17.4286 37.8411 17.1919ZM28.9946 28.3144C28.9811 28.4451 28.9418 28.5718 28.8792 28.6873C28.8166 28.8028 28.7318 28.9048 28.6297 28.9874C28.5276 29.0701 28.4102 29.1318 28.2842 29.169C28.1582 29.2063 28.0261 29.2183 27.8955 29.2043C25.3057 28.9324 22.6945 28.9324 20.1047 29.2043C19.8415 29.2311 19.5783 29.1524 19.373 28.9856C19.1676 28.8187 19.0367 28.5773 19.0091 28.3141C18.9814 28.0509 19.0591 27.7875 19.2253 27.5816C19.3914 27.3756 19.6324 27.2439 19.8955 27.2153C22.6244 26.9287 25.3758 26.9287 28.1047 27.2153C28.2353 27.2291 28.362 27.2684 28.4774 27.331C28.5928 27.3937 28.6947 27.4785 28.7773 27.5806C28.86 27.6826 28.9217 27.8 28.959 27.9259C28.9963 28.0518 29.0084 28.1838 28.9946 28.3144Z",
    fill: "url(#paint0_linear_393_972)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_393_972",
    x1: 6.84873,
    y1: 9.52858,
    x2: 41.0929,
    y2: 33.4693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA53D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C36F09"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_393_972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradePlanBgExpired);
export default __webpack_public_path__ + "static/media/upgrade-plan-bg-expired.d3a5c2cf746aa2f87380b7cd247ed6d1.svg";
export { ForwardRef as ReactComponent };